
export async function getProgram(paraProg){
    var self = paraProg;
            self.id = self.$route.params.id;
    paraProg.programId = self.id;
    paraProg.$HttpClient.commonService.url = "Programs/GetProgram?programId=" + self.id;

    paraProg.$HttpClient.commonService.get()
                .then(r => r.json())
                .then(json => {
                    paraProg.programData = json.programMainInformation;
                    console.log(paraProg.programData)
                    paraProg.contactUsURL = json.contactUsURL;
                    paraProg.applicantURL = json.applicantURL;
                    self.loading = false;
                });
}


export async function getProgramType(paraProgType) {

    var self = paraProgType;
    self.typeId = self.$route.params.typeId;
    // self.id = self.$route.params.id;
    paraProgType.programId = self.$route.params.id;
    paraProgType.typeId = self.typeId;
    paraProgType.$HttpClient.commonService.url = "Programs/GetProgramByType?typeId=" + self.typeId + "&id=" + paraProgType.programId;
    paraProgType.$HttpClient.commonService.get()
        .then(r => r.json())
        .then(json => {
            paraProgType.program = json.model;
            paraProgType.contactUsURL = json.contactUsURL;
            paraProgType.applicantURL = json.applicantURL;
        });
}

export async function OnCompletedLoadPage() {
    const plugin = document.createElement("script");
    plugin.setAttribute(
        "src",
        process.env.BASE_URL + 'Content/js/functions.js'
    );
    plugin.async = true;
    document.head.appendChild(plugin);
}